import React, { createContext, useContext, useState, ReactNode } from 'react';

// Create the Context
const AptcContext = createContext<{
    newAptc: number;
    electedAptc: number;
    setNewAptc: React.Dispatch<React.SetStateAction<number>>;
} | null>(null);

// Provider Component
export const AptcProvider = ({ electedAptc, children }: { electedAptc: number; children: ReactNode }) => {
    const [newAptc, setNewAptc] = useState(electedAptc);
    return <AptcContext.Provider value={{ newAptc, setNewAptc, electedAptc }}>{children}</AptcContext.Provider>;
};

// Custom Hook for Context
export const useAptcContext = () => {
    const context = useContext(AptcContext);
    if (!context) {
        throw new Error('useAptcContext must be used within an AptcProvider');
    }
    return context;
};
